/* eslint-disable react/jsx-props-no-spreading */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { background as backgroundStyles, space as spaceStyles, compose, } from 'styled-system';
import { muiBankTheme } from '@ally/metronome-ui';
import { applicationMaxWidth } from './constants';
var StyledMaxAppWidth = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ",
    "\n  ", "\n"])), function (_a) {
    var $fullWidthSmDown = _a.$fullWidthSmDown, _b = _a.theme, media = _b.media, space = _b.space;
    return "\n    margin: auto;\n    width: 100%;\n    max-width: " + applicationMaxWidth.px + ";\n    padding: 0;\n\n    " + ($fullWidthSmDown
        ? ''
        : "\n        " + media.down('md') + " {\n          padding-left: " + space.sm + ";\n          padding-right: " + space.sm + ";\n        }\n      ") + "\n\n    " + media.up('md') + " {\n      padding-left: " + space.md + ";\n      padding-right: " + space.md + ";\n    }\n  ";
}, compose(backgroundStyles, spaceStyles));
export var MaxAppWidth = function (_a) {
    var fullWidthSmDown = _a.fullWidthSmDown, children = _a.children, others = __rest(_a, ["fullWidthSmDown", "children"]);
    return (React.createElement(ThemeProvider, { theme: muiBankTheme },
        React.createElement(StyledMaxAppWidth, __assign({ "$fullWidthSmDown": fullWidthSmDown }, others), children)));
};
var templateObject_1;
//# sourceMappingURL=MaxAppWidth.js.map